import { createSelector } from 'reselect';

export const selectState = (state) => state || {};
export const selectCart = createSelector(selectState, (state) => state?.cartDetails || {});
export const selectStateCache = createSelector(selectCart, (cart) => cart.stateCache || Date.now());
